import {pageInfo, initPage, detail, exportData,conOrderDetail, orderConfirmSubmit, orderConfirmReject, setOriginalOrderNo, updateOrderDtQtyUpload, updateOrderDtQtyConfirm, updateOrderDtProductUpload, updateOrderDtProductConfirm} from './../api';
import { dcList, customerGroupList } from '../../../../api'
import { Message } from 'element-ui';
const confirm = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    initPageObj: null,
    dcListObj: null,
    customerGroupListObj: null,
    orderDetailObj: null,
    orderConfirmSubmitResp: null,
    orderConfirmRejectResp: null,
    setOriginalOrderNoObj: null,
    updateOrderDtQtyUploadObj: null,
    updateOrderDtQtyConfirmObj: null,
    updateOrderDtProductUploadObj: null,
    updateOrderDtProductConfirmObj: null,
    exportObj:null,
    orderConDetailObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true, (item.transOrderFlag == '10' && item.uploadCustomerFlag == 'Y')] }));
    },
    DC_LIST_DATA(state, data) {
      state.dcListObj = data.obj || [];
    },
    CUSTOMERGROUPLIST_DATA(state, data) {
      state.customerGroupListObj = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    ORDER_DETAIL(state,data) {
      state.orderDetailObj = data.obj;
    },
    ORDERCONFIRMSUBMIT_DATA(state,data) {
      state.orderConfirmSubmitResp= data;
    },
    ORDERCONFIRMREJECT_DATA(state,data) {
      state.orderConfirmRejectResp= data;
    },
    SET_ORIGINAL_ORDERNO(state,data) {
      state.setOriginalOrderNoObj= data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    UPDATEORDERDTQTY_UPLOAD(state,data){
      state.updateOrderDtQtyUploadObj = data;
    },
    UPDATEORDERDTQTY_CONFIRM(state,data){
      state.updateOrderDtQtyConfirmObj = data;
    },
    UPDATEORDERDTPRODUCT_UPLOAD(state,data){
      state.updateOrderDtProductUploadObj = data;
    },
    UPDATEORDERDTPRODUCT_CONFIRM(state,data){
      state.updateOrderDtProductConfirmObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    ORDER_CON_DETAIL(state, data) {
      state.orderConDetailObj = data.obj;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //dc
    async dcList({ commit }, obj) {
      let resp = await dcList(obj);
      commit('DC_LIST_DATA', resp);
    },
    //客户组
    async customerGroupList({ commit }, obj) {
      let resp = await customerGroupList(obj);
      commit('CUSTOMERGROUPLIST_DATA', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async detail({commit}, obj){
      let resp = await detail(obj);
      commit('ORDER_DETAIL', resp);
    },
    //转订单事件
    async orderConfirmSubmit({commit}, obj){
      let resp = await orderConfirmSubmit(obj);
      commit('ORDERCONFIRMSUBMIT_DATA', resp);
    },
    //转订单拒绝
    async orderConfirmReject({commit}, obj){
      let resp = await orderConfirmReject(obj);
      commit('ORDERCONFIRMREJECT_DATA', resp);
    },
    // 设置原始客户订单号
    async setOriginalOrderNo({ commit }, obj) {
      let resp = await setOriginalOrderNo(obj);
      commit('SET_ORIGINAL_ORDERNO', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //修改订单明细数量导入
    async updateOrderDtQtyUpload({commit}, obj){
      let resp = await updateOrderDtQtyUpload(obj);
      commit('UPDATEORDERDTQTY_UPLOAD', resp);
    },

    //修改订单明细数量-确认修改
    async updateOrderDtQtyConfirm({commit}, obj){
      let resp = await updateOrderDtQtyConfirm(obj);
      commit('UPDATEORDERDTQTY_CONFIRM', resp);
    },
    //新旧品替换导入
    async updateOrderDtProductUpload({commit}, obj){
      let resp = await updateOrderDtProductUpload(obj);
      commit('UPDATEORDERDTPRODUCT_UPLOAD', resp);
    },

    //新旧品替换-确认修改
    async updateOrderDtProductConfirm({commit}, obj){
      let resp = await updateOrderDtProductConfirm(obj);
      commit('UPDATEORDERDTPRODUCT_CONFIRM', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //
    async conOrderDetail({commit}, obj){
      let resp = await conOrderDetail(obj);
      commit('ORDER_CON_DETAIL', resp);
    },
  }
}
export default confirm



// WEBPACK FOOTER //
// ./src/page/order/confirm/store/confirm.store.js